<script>
export default {
  props: {
    to: { type: String, default: '' },
    name: { type: String, default: '' },
    icon: { type: String, default: '' },
    count: { type: String, default: '' },
    isChildMenuActive: { type: Boolean, default: false },
    openInNewPage: { type: Boolean, default: false },
  },
  computed: {
    isLucideLikeIcon() {
      return typeof this.icon === 'string' && this.icon.startsWith('i-');
    },
  },
};
</script>

<template>
  <router-link v-slot="{ href, isActive, navigate }" :to="to" custom>
    <a
      v-tooltip.right="$t(`SIDEBAR.${name}`)"
      :href="href"
      class="relative my-3 flex size-8 shrink-0 items-center justify-center rounded-lg text-slate-100 hover:bg-[#3cbeb6] hover:text-slate-100 dark:text-slate-100 dark:hover:bg-[#3cbeb6] dark:hover:text-slate-100 md:my-[15px] md:size-[39px]"
      :class="{
        'rounded-md bg-[#3cbeb6] text-woot-25 hover:bg-woot-50 dark:bg-[#3cbeb6]':
          isActive || isChildMenuActive,
      }"
      :rel="openInNewPage ? 'noopener noreferrer nofollow' : undefined"
      :target="openInNewPage ? '_blank' : undefined"
      @click="navigate"
    >
      <span
        v-if="isLucideLikeIcon"
        :class="[
          icon,
          'size-5 shrink-0 md:size-7',
          {
            'text-woot-25': isActive || isChildMenuActive,
            'text-[#2d398e] md:size-7': !isActive && !isChildMenuActive,
          },
        ]"
      />
      <fluent-icon
        v-else
        :icon="icon"
        class="size-5 shrink-0 md:size-7"
        :class="{
          'text-woot-25': isActive || isChildMenuActive,
          'text-[#2d398e]': !isActive && !isChildMenuActive,
        }"
      />
      <span class="sr-only">{{ name }}</span>
      <span
        v-if="count"
        class="absolute -right-0.5 -top-0.5 z-[1] flex min-h-[1.125rem] min-w-[1.125rem] items-center justify-center rounded-full bg-woot-500 px-1 text-[10px] font-bold leading-none text-white shadow-sm"
      >
        {{ count }}
      </span>
    </a>
  </router-link>
</template>
